export const networks = ['xrpl:1', 'xrpl:0'] as const;

export type NETWORK = (typeof networks)[number];

export interface NetworkConfig {
  name: string;
  wsUrl: string;
  explorerUrl: string;
}

export const NETWORK_MAP: Record<NETWORK, NetworkConfig> = {
  'xrpl:0': {
    name: 'XRPL Mainnet',
    wsUrl: 'wss://s1.ripple.com',
    explorerUrl: 'https://livenet.xrpl.org',
  },
  'xrpl:1': {
    name: 'XRPL Testnet',
    wsUrl: 'wss://s.altnet.rippletest.net:51233',
    explorerUrl: 'https://testnet.xrpl.org',
  },
};

export function getNetworkConfig(networkId: string): NetworkConfig {
  return NETWORK_MAP[networkId as NETWORK] || NETWORK_MAP['xrpl:1'];
}
